import React from "react";
import "./flight-search-card.scss";
import TabList from "../Tabs/TabList";
import ImportantText from "../ImportantText/ImportantText";
import { useTranslation } from "react-i18next";

const FlightSearchCard = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="card-container">
        <div className="card-title">{`${t("status-page.page-title")}`}</div>
        <div className="card-subtitle">{`${t("status-page.subtitle")}`}</div>
        <TabList />
      </div>
      <div className="display-desktop">
        <ImportantText />
      </div>
    </>
  );
};

export default FlightSearchCard;
